import styled from 'styled-components'

import { ProfileBoardStatisticsSkeleton } from '@root/features/profile/board-statistics/ui/profile-board-statistics-skeleton'
import { StatisticsTablesSkeleton } from '@root/features/profile/board-statistics/ui/profile-board-statistics-tables-skeleton'
import { ProfileHeaderSkeleton } from '@root/features/user/profile-header/ui/common/profile-header-skeleton'
import { PhishingCheckBlockSkeleton } from '@root/features/user/user-trading-analytics/ui/fishing-checks/fishing-checks-block-skeleton'
import { UserProfilePnlSkeleton } from '@root/features/user/user-trading-analytics/ui/pnl/user-profile-pnl-skeleton'
import { FadeOverflow, UnderlineTabsSkeleton } from '@root/shared/ui-kit'

export const ProfileScreenSkeleton: React.FC = () => {
  return (
    <Root mode="always" variant="vertical" inlineStart={16} inlineEnd={16}>
      <PaddedGroup>
        <ProfileHeaderSkeleton />
        <ProfileBoardStatisticsSkeleton />
        <PnlChart />
      </PaddedGroup>
      <StatisticsTabs />
      <PaddedGroup>
        <PhishingCheckBlockSkeleton />
      </PaddedGroup>
      <Tables columnsCount={3} />
    </Root>
  )
}

const Root = styled(FadeOverflow)`
  display: grid;
  gap: 10px;
  position: relative;
  overflow: auto;
  height: 100%;
  min-width: 0;

  padding-block-start: 12px;
`

const PnlChart = styled(UserProfilePnlSkeleton)`
  height: 325px;
`

const Tables = styled(StatisticsTablesSkeleton)`
  border-radius: 0;
  margin-top: 4px;
`

const PaddedGroup = styled.div`
  padding-inline: 12px;
  display: grid;
  gap: 14px;
`

const StatisticsTabs = styled(UnderlineTabsSkeleton)`
  padding-inline: 12px;
  border-bottom: 2px solid #212121;
`
